import { render, staticRenderFns } from "./NewsFilters.vue?vue&type=template&id=72a7d47e&"
import script from "./NewsFilters.vue?vue&type=script&lang=js&"
export * from "./NewsFilters.vue?vue&type=script&lang=js&"
import style0 from "./NewsFilters.vue?vue&type=style&index=0&id=72a7d47e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports